import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

export const GuestsLimitMessage = () => {
  return (
    <div className="flex items-center gap-2 py-1 px-2">
      <div>
        <Icon icon={IconsMap.INFO} className="w-6 h-6 text-red-500" />
      </div>
      <p>
        Guest limit reached. Sending invites will add seats (1 member = 3 guests) and automatically charge your card.
      </p>
    </div>
  );
};
